import { connect } from 'react-redux';

const mapStateToProps = state => ({
  urls: state.mainreducer.urls,
  formAuthToken: state.mainreducer.formAuthToken,
  formPostUrl: state.mainreducer.aboutusFormUrl
});

export default AboutUsLeftPart => connect(mapStateToProps, null)(AboutUsLeftPart);
